/* CalmOrbit landing — shared behaviours.
   Safe for the Shopify theme editor: everything re-initialises on
   shopify:section:load and guards against double-binding. No globals leak. */
(function () {
  function revealInit(scope) {
    var els = (scope || document).querySelectorAll('.co-reveal:not([data-co-revealed])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('co-in'); e.setAttribute('data-co-revealed', '1'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('co-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { e.setAttribute('data-co-revealed', '1'); io.observe(e); });
  }

  function accordionInit(scope) {
    var items = (scope || document).querySelectorAll('[data-co-acc-btn]:not([data-co-acc-bound])');
    items.forEach(function (btn) {
      btn.setAttribute('data-co-acc-bound', '1');
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-co-acc-item]');
        var body = item.querySelector('[data-co-acc-body]');
        var open = item.classList.toggle('co-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
        // optional single-open behaviour within a group
        var group = btn.closest('[data-co-acc-single]');
        if (open && group) {
          group.querySelectorAll('[data-co-acc-item].co-open').forEach(function (other) {
            if (other !== item) {
              other.classList.remove('co-open');
              other.querySelector('[data-co-acc-btn]').setAttribute('aria-expanded', 'false');
              other.querySelector('[data-co-acc-body]').style.maxHeight = '0px';
            }
          });
        }
      });
    });
  }

  function initAll(scope) { revealInit(scope); accordionInit(scope); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-init when a section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
